var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('SettingsUsersCard',_vm._b({},'SettingsUsersCard',{
        currentUser: _vm.currentUser,
        users: _vm.users,
        saveUserPermission: _vm.saveUserPermission,
        removeUserPermission: _vm.removeUserPermission,
        resendInvitation: _vm.resendInvitation
      },false))],1),_c('v-flex',{attrs:{"xs12":""}},[_c('SettingsSpaceCard',_vm._b({},'SettingsSpaceCard',{ space: _vm.currentSpace, deleteSpace: _vm.deleteSpace, updateSpace: _vm.updateSpace, isOwner: _vm.isOwner },false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }